import { TRoute } from "@/types";

import { Search } from "@/views/Search/Search";

/**
 * Every address the home page answers to (see UHomePath): the menu's
 * home entry links to the first and is active on all of them.
 */
export const HOME_PATHS = ["/", "/view/:viewId/*", "/tasks/:taskId"];

/** The views section: the list, and a view's page by prefix. */
export const VIEWS_PATHS = ["/views"];

/** The projects section: the list and a project's page. */
export const PROJECTS_PATHS = ["/projects", "/projects/:id"];

/**
 * Everything the mobile "Me" tab gathers: the tab stays lit on each of
 * these pages, reached from it.
 */
export const ME_PATHS = [
	"/me",
	...VIEWS_PATHS,
	"/profile",
	"/subscription",
	"/workspace",
	"/companies",
	"/clients",
	"/reports",
	"/invoices",
	"/admin",
];

/**
 * The mobile nav bar's tabs, titles as i18n keys. The new-task button
 * and the "Me" tab are the bar's own.
 */
export const NavBarRoutes: TRoute[] = [
	{
		name: "Home",
		title: "global.home",
		path: HOME_PATHS,
		picto: "home",
	},
	{
		name: "Search",
		title: "search.placeholder",
		path: ["/search"],
		picto: "search",
		element: Search,
		exact: true,
	},
	{
		name: "projects",
		title: "projects.title",
		picto: "folder",
		path: PROJECTS_PATHS,
	},
];
